<script lang="ts" setup>
defineProps({
  errorDisabled: {
    type: Boolean,
    default: true,
  },
  error: {
    type: String,
    required: false,
  },
  name: {
    type: String,
    required: true,
  },
  label: {
    type: String,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div class="flex flex-col">
    <label :for="name" class="mb-3 text-input-label text-left" :class="{ 'c-text-inactive': disabled }">{{ label }}</label>
    <slot />
    <span
      v-if="!errorDisabled"
      class="text-input-error c-text-error mt-1.5 text-small min-h-4.5 w-full text-wrap"
      :class="{
        'select-none pointer-events-none opacity-0': !error,
      }"
    >
      {{ error }}
    </span>
  </div>
</template>
